import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useUserStatus } from "../../components/liveStatus";
import ImagePreviewLightbox from "../../components/ImagePreviewLightbox";
import { Image } from "react-bootstrap";
import { VideoCameraIcon } from "../../components/SVGIcon";
import StatusDot from "../../components/UserStatusdotColor";
import {
  chatLastMessageAtom,
  chatUnseenCountsAtom,
} from "../../states/chatAtoms";
import { useAtomValue } from "jotai";
import moment from "moment";
const ConversationItem = ({
  element,
  conversationId,
  setConversationId,
  auth,
}) => {
  const anotherMember = element?.conversationMembers?.find(
    (e) => e.user_id !== auth?.user?.id,
  );
  const status = anotherMember?.user?.status ?? element?.createdBy?.status;
  const getOtherUserId = () => {
    if (anotherMember?.user?.id) {
      return anotherMember.user.id;
    }
    if (element?.createdBy?.id && element.createdBy.id !== auth?.user?.id) {
      return element.createdBy.id;
    }
    return null;
  };
  const id = getOtherUserId();
  const liveUser = useUserStatus(id);
  const unseenCounts = useAtomValue(chatUnseenCountsAtom);
  const count = unseenCounts[element.id] || 0;
  const isActive = conversationId === element?.id;
  const handleSelectConversation = () => {
    if (conversationId !== element?.id) {
      setConversationId(element?.id);
    }
  };
  const getPreviewLabel = (text = "") => {
    if (text.includes("{{IMAGE}}")) return "🖼️ Image";
    if (text.includes("{{VIDEO}}")) return "🎥 Video";
    if (text.includes("{{MEDIA}}")) return "📎 Media";

    return text;
  };

  const formatMessageTime = (dateString) => {
    if (!dateString) return "";

    const messageDate = moment(dateString);
    const now = moment();

    // Check if it's the same calendar day
    if (messageDate.isSame(now, "day")) {
      return messageDate.format("LT"); // e.g., 2:30 PM
    }

    // Check if it was yesterday
    if (messageDate.isSame(now.clone().subtract(1, "days"), "day")) {
      return "Yesterday";
    }

    // Check if it is within the last 7 days (but not today or yesterday)
    if (messageDate.isAfter(now.clone().subtract(7, "days"))) {
      return messageDate.format("dddd"); // e.g., Friday
    }
    // Older than a week
    return messageDate.format("L");
  };

  const lastMessages = useAtomValue(chatLastMessageAtom);
  const lastMsg = lastMessages[element.id];
  const timestampRaw = lastMsg?.createdAt || element.lastMsgTime;
  const displayTime = formatMessageTime(timestampRaw);

  const previewText = getPreviewLabel(lastMsg?.text ?? element?.lastMsg ?? "");
  const chooseProfilePic = () => {
    if (anotherMember?.user?.firstName && anotherMember?.user?.lastName) {
      return anotherMember.user.profilePic || "/images/user-circle.svg";
    }

    if (element?.createdBy?.firstName && element?.createdBy?.lastName) {
      return element.createdBy.profilePic || "/images/user-circle.svg";
    }

    return "/images/user-circle.svg";
  };

  const profilePic = chooseProfilePic();
  useEffect(() => {
    if (conversationId) {
      const timer = setTimeout(() => {
        const el = document.getElementById(`conv-${conversationId}`);
        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
          });
        }
      }, 250);

      return () => clearTimeout(timer);
    }
  }, [conversationId]);
  return (
    <motion.div
      key={element?.id}
      id={`conv-${element.id}`}
      layout
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      className={`chat-list-item ${isActive ? "active" : ""}`}
      onClick={handleSelectConversation}
      style={{
        cursor: "pointer",
        backgroundColor: isActive ? "#eef6ff" : "transparent",
      }} // optional: visual clarity
    >
      <ImagePreviewLightbox className="chat-avatar md" src={profilePic}>
        <Image
          className="rounded-pill object-fit-cover"
          src={profilePic}
          onError={(e) => {
            e.target.src = "/images/user-circle.svg";
          }}
          width={48}
          height={48}
          alt="User"
        />
        {console.log("liveUser", liveUser, anotherMember?.user?.id)}
        <StatusDot statusCode={liveUser ?? status ?? 0} />
      </ImagePreviewLightbox>

      <div className="chat-item-msg d-flex flex-column align-items-start justify-content-between gap-1 flex-grow-1">
        <div className="fs-16 fw-semibold text-gray-700">
          <span className="text-truncate d-block">
            {anotherMember?.user?.firstName ?? element?.createdBy?.firstName}{" "}
            {anotherMember?.user?.lastName ?? element?.createdBy?.lastName}
          </span>
          <span className="text-truncate fs-14 fw-normal text-gray-500 d-block">
            {element?.conversationType !== "internal chat"
              ? (anotherMember?.user?.companyName ??
                element?.createdBy?.companyName)
              : previewText}
          </span>
        </div>

        {element?.conversationType?.includes("support call") && (
          <div className="fs-14 fw-normal text-gray-500">Added Video call</div>
        )}
      </div>

      {element?.conversationType?.includes("call") && (
        <VideoCameraIcon className="chat-list-item-icon" />
      )}
      <div className="chat-item-time-unseen d-flex flex-column align-items-end  align-self-baseline">
        <span
          className={`chat-item-time fs-15 ${
            count > 0 ? "text-red-500" : "text-gray-500"
          }`}
        >
          {displayTime}
        </span>
        {count > 0 && !isActive && <span className="count">{count}</span>}
      </div>
    </motion.div>
  );
};

export default ConversationItem;
